import React, { useState } from 'react';
import { Button } from '@components';
import { Icon, Typography } from 'gd-design-library';
import styles from './FacetAccordion.module.scss';
import classnames from 'classnames/bind';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

const cx = classnames.bind(styles);

const CN = 'facet-accordion';
const summaryClassName = `${CN}__summary`;
const detailsClassName = `${CN}__details`;
const detailsScrollableClassName = `${detailsClassName}--scrollable`;

interface FacetAccordionProps {
  label: string;
  hasShowMoreButton?: boolean;
}

export const FacetAccordion: React.FC<React.PropsWithChildren<FacetAccordionProps>> = ({
  children,
  label,
  hasShowMoreButton
}) => {
  const [ expanded, setExpanded ] = useState(true);
  const [ showMore, setShowMore ] = useState(false);

  return (
    <Accordion
      className={ cx(CN) }
      elevation={ 0 }
      disableGutters
      expanded={ expanded }
      onChange={ (): void => setExpanded(!expanded) }
    >
      <AccordionSummary
        className={ cx(summaryClassName) }
        expandIcon={ <Icon name='keyboardArrowDown' width={ 14 } height={ 14 } /> }
      >
        <Typography variant='h6'>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails className={ `${cx(detailsClassName)} ${hasShowMoreButton && !showMore ? cx(detailsScrollableClassName) : ''}` }>
        { children }
      </AccordionDetails>
      {hasShowMoreButton && !showMore && (
        <Button variant='text' onClick={ (): void => setShowMore(true) }>
          Show More Options
        </Button>
      )}
    </Accordion>
  );
};
